"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Base2 = _interopRequireDefault(require("./Base"));
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable */
var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
var Vimeo = exports["default"] = /*#__PURE__*/function (_Base) {
  _inherits(Vimeo, _Base);
  function Vimeo() {
    var _this;
    _classCallCheck(this, Vimeo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Vimeo, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });
    return _this;
  }
  _createClass(Vimeo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        url = _this$props.url,
        config = _this$props.config;
      if (!url && config.vimeo.preload) {
        this.preloading = true;
        this.load(BLANK_VIDEO_URL);
      }
      _get(_getPrototypeOf(Vimeo.prototype), "componentDidMount", this).call(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ieClearTimer();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.url !== nextProps.url || this.props.controls !== nextProps.controls;
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;
      if (!url) {
        return;
      }
      var id = url.match(MATCH_URL)[3];
      this.duration = null;
      if (this.isReady) {
        this.player.loadVideo(id);
        return;
      }
      if (this.loadingSDK) {
        this.loadOnReady = url;
        return;
      }
      this.loadingSDK = true;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (_Vimeo2) {
        if (!_this2.container) {
          return;
        }
        var iframe = _this2.container;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style['min-height'] = '360px';
        iframe.style['border-width'] = '0';
        _this2.player = new _Vimeo2.Player(_this2.container);
        _this2.player.on('loaded', function () {
          _this2.onReady();
        });
        _this2.player.on('play', function (_ref) {
          var duration = _ref.duration;
          _this2.duration = duration;
          _this2.onPlay();
        });
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });
        _this2.player.on('ended', function () {
          _this2.onEnded();
        });
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var seconds = _ref2.seconds;
          _this2.ieSetTimer();
          _this2.currentTime = seconds;
        });
        _this2.player.on('progress', function (_ref3) {
          var seconds = _ref3.seconds;
          _this2.secondsLoaded = seconds;
        });
      }, this.props.onError);
    }
  }, {
    key: "isIE",
    value: function isIE() {
      var ua = window.navigator.userAgent;
      return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
    }
  }, {
    key: "ieHack",
    value: function ieHack() {
      // For some reason, IE seems to hang up sometimes on Vimeo videos
      // If it hangs up near the end, without an explicit pause, give it a push
      if (this.duration - this.currentTime < 2) {
        this.pause();
        this.play();
      }
    }
  }, {
    key: "ieSetTimer",
    value: function ieSetTimer() {
      var _this3 = this;
      if (this.isIE()) {
        if (this.IEhacktimer) {
          clearTimeout(this.IEhacktimer);
        }
        this.IEhacktimer = setTimeout(function () {
          _this3.ieHack();
        }, 1000);
      }
    }
  }, {
    key: "ieClearTimer",
    value: function ieClearTimer() {
      if (this.isIE()) {
        if (this.IEhacktimer) {
          clearTimeout(this.IEhacktimer);
        }
      }
    }
  }, {
    key: "onEnded",
    value: function onEnded() {
      this.ieClearTimer();
      this.props.onEnded();
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.ieClearTimer();
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.ieClearTimer();
      if (this.preloading) return;
      this.callPlayer('unload');
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      var seconds = _get(_getPrototypeOf(Vimeo.prototype), "seekTo", this).call(this, amount);
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "iframeUrl",
    value: function iframeUrl() {
      if (!this.props.url) {
        return '';
      }
      var url = this.props.url.split('?')[0];

      // let mobile = /Android|iPad|iPhone|iPod/i.test(navigator.userAgent) && !window.MSStream;

      // Disabling autoplay all the time unless muted
      // let autoplay = this.props.playing && !mobile
      var autoplay = this.props.playing && this.props.muted;

      // Force controls to appear all the time unless muted
      // let controls = this.props.controls || ( mobile && this.props.mobileControls )
      var controls = this.props.controls || !this.props.muted;
      var referUrl = window.cccisd && window.cccisd.boilerplate && window.cccisd.boilerplate.settings && window.cccisd.boilerplate.settings.publicUrl || '';
      return url + '?background=' + !controls + '&autoplay=' + autoplay + '&mute=' + this.props.muted + '&loop=' + this.props.loop + '&refer=' + referUrl;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        width: "100%",
        height: "100%",
        ref: this.ref,
        src: this.iframeUrl(),
        allowFullScreen: true
      });
    }
  }], [{
    key: "canPlay",
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);
  return Vimeo;
}(_Base2["default"]);
_defineProperty(Vimeo, "displayName", 'Vimeo');